/**
 * Génère un UUID v4 utilisable comme `x-request-id` pour corréler
 * les requêtes front avec les logs serveur.
 *
 * Utilise `crypto.randomUUID()` dans les navigateurs modernes (>= 2021),
 * avec un fallback pur Math.random() pour les runtimes plus anciens.
 */
export function generateCorrelationId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
